"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _AuComponent = _interopRequireDefault(require("./AuComponent"));
var _constants = require("../../constants");
var _context, _context2, _context3, _context4, _context5, _context6;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "mini_drop_down-module__container___nGuJy",
  "active": "mini_drop_down-module__active___fLzGZ",
  "icon": "mini_drop_down-module__icon___fK_rK",
  "options": "mini_drop_down-module__options___iiw_G",
  "sort": "mini_drop_down-module__sort___cQZ1G mini_drop_down-module__icon___fK_rK",
  "map": "mini_drop_down-module__map___ptfJx mini_drop_down-module__icon___fK_rK",
  "clock": "mini_drop_down-module__clock___KMebX mini_drop_down-module__icon___fK_rK",
  "caret": "mini_drop_down-module__caret___Mqrj7 mini_drop_down-module__icon___fK_rK",
  "download": "mini_drop_down-module__download___DNz3u mini_drop_down-module__icon___fK_rK",
  "more": "mini_drop_down-module__more___qvzn9",
  "text": "mini_drop_down-module__text___WFLod",
  "disabled": "mini_drop_down-module__disabled____HrGq",
  "left": "mini_drop_down-module__left___B9OXz",
  "right": "mini_drop_down-module__right___fJ8KJ",
  "above": "mini_drop_down-module__above___qTWUY",
  "below": "mini_drop_down-module__below___JFU5V",
  "option": "mini_drop_down-module__option___EHpoI"
};
class MiniDropDown extends _AuComponent.default {
  static propTypes = {
    type: T.oneOf(['sort', 'map', 'clock', 'caret', 'download', 'more']).isRequired,
    align: T.oneOf(['left', 'right']).isRequired,
    className: T.string,
    iconClassName: T.string,
    textClassName: T.string,
    optionsClassName: T.string,
    displayId: T.string,
    displayString: T.string,
    options: T.arrayOf(T.shape({
      displayId: T.string,
      displayString: T.string,
      disabled: T.bool,
      onClick: T.func
    }).isRequired),
    disabled: T.bool
  };
  static defaultProps = {
    type: 'sort',
    align: 'right',
    disabled: false
  };
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      position: 'below'
    };
  }
  componentDidMount() {
    this._mounted = true;
  }
  componentWillUnmount() {
    this._mounted = false;
    // cleanup
    window.removeEventListener('click', this.closeDropDown);
  }
  setDirection(container) {
    if (this._mounted && !this.props.disabled && !this.state.active) {
      this.setState({
        active: true
      });
      const button = container.getBoundingClientRect();
      const options = this.optionsRef.getBoundingClientRect();
      if (button.bottom > window.innerHeight - (options.height + 36 /*footer height*/)) {
        if (this.state.position != 'above') {
          this.setState({
            position: 'above'
          });
        }
      }
    }
  }
  openDropDown = (0, _bind.default)(_context = this.openDropDown).call(_context, this);
  openDropDown(e) {
    this.setDirection(e.target);
    // add event listener after "click" has been propagated
    (0, _setTimeout2.default)(() => window.addEventListener('click', this.closeDropDown, false));
  }
  onMouseOverHandler = (0, _bind.default)(_context2 = this.onMouseOverHandler).call(_context2, this);
  onMouseOverHandler() {
    this.setDirection(this.containerRef);
  }
  setContainerRef = (0, _bind.default)(_context3 = this.setContainerRef).call(_context3, this);
  setContainerRef(ref) {
    if (ref) {
      this.containerRef = ref;
    }
  }
  setOptionsRef = (0, _bind.default)(_context4 = this.setOptionsRef).call(_context4, this);
  setOptionsRef(ref) {
    if (ref) {
      this.optionsRef = ref;
    }
  }
  closeDropDown = (0, _bind.default)(_context5 = this.closeDropDown).call(_context5, this);
  closeDropDown() {
    if (this._mounted && this.state.active) {
      this.setState({
        active: false
      });
    }
    window.removeEventListener('click', this.closeDropDown);
  }
  clickHandler = (0, _bind.default)(_context6 = this.clickHandler).call(_context6, this);
  clickHandler(e) {
    if (this.state.active) {
      this.closeDropDown();
    } else {
      this.openDropDown(e);
    }
  }
  render() {
    const {
      options,
      type,
      align,
      disabled,
      displayId,
      displayString
    } = this.props;
    const {
      className,
      iconClassName,
      textClassName,
      optionsClassName
    } = this.props;
    const {
      active,
      position
    } = this.state;
    const classes = (0, _classnames.default)(styles.container, styles[align], styles[position], {
      [styles.active]: active,
      [styles.disabled]: disabled
    }, className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes,
      onClick: this.clickHandler,
      onMouseOver: this.onMouseOverHandler,
      ref: this.setContainerRef
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(styles[type], iconClassName)
    }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: displayId,
      displayString: displayString,
      className: (0, _classnames.default)(styles.text, textClassName)
    }), !disabled && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.options, optionsClassName),
      ref: this.setOptionsRef
    }, (0, _map.default)(options).call(options, ({
      disabled,
      ...option
    }) => /*#__PURE__*/_react.default.createElement(_AutoIntl.default, (0, _extends2.default)({}, option, {
      onClick: !disabled && option.onClick ? option.onClick : _constants.NOOP,
      key: option.displayId || option.displayString,
      className: (0, _classnames.default)(styles.option, {
        [styles.disabled]: disabled
      }),
      "data-tcl": "MiniDropDown-option",
      tag: "div"
    })))));
  }
}
exports.default = MiniDropDown;